import { EntityData } from '@/components/TriggerSetup/logic/types/entity-data.type'
import { snakeCase } from 'lodash'
import ForwardReplyMessageToTargetActionSetupView
    from '@/components/TriggerSetup/actions/ForwardReplyMessageToTargetAction/ForwardReplyMessageToTargetActionSetupView.vue'
import { getTagsByFieldKey } from '@/mixins/TariffsTagsHelper'

const action: () => EntityData = () => {
    return {
        'setupView': ForwardReplyMessageToTargetActionSetupView,
        'structure': {
            'type': 'ForwardReplyMessageToTargetAction',
            'target': null,
            'chance': 100,
        },
        'titleKey': `trigger_action_${ snakeCase('ForwardReplyMessageToTargetAction') }`,
        'limited': getTagsByFieldKey('ForwardReplyMessageToTargetAction'),
    }
}

export default action
